import React, { memo, useEffect, useRef, useState } from "react";

import { IranMap } from "react-iran-map";
import { HandleErrors } from "../../utils/handleErrors";
import { getMapDataService } from "../../services/event.service";
import { useSelector } from "react-redux";

const Map = (props) => {
  const [isReady, setIsReady] = useState(false);
  const health = useSelector((root) => root.app.health);

  const [deviceCount, setDeviceCount] = useState({
    ardabil: 0,
    isfahan: 0,
    alborz: 0,
    ilam: 0,
    eastAzerbaijan: 0,
    westAzerbaijan: 0,
    bushehr: 0,
    tehran: 0,
    chaharmahalandBakhtiari: 0,
    southKhorasan: 0,
    razaviKhorasan: 0,
    northKhorasan: 0,
    khuzestan: 0,
    zanjan: 0,
    semnan: 0,
    sistanAndBaluchestan: 0,
    fars: 0,
    qazvin: 0,
    qom: 0,
    kurdistan: 0,
    kerman: 0,
    kohgiluyehAndBoyerAhmad: 0,
    kermanshah: 0,
    golestan: 0,
    gilan: 0,
    lorestan: 0,
    mazandaran: 0,
    markazi: 0,
    hormozgan: 0,
    hamadan: 0,
    yazd: 0,
  });

  const [totalRisk, setTotalRisk] = useState({
    ardabil: 0,
    isfahan: 0,
    alborz: 0,
    ilam: 0,
    eastAzerbaijan: 0,
    westAzerbaijan: 0,
    bushehr: 0,
    tehran: 0,
    chaharmahalandBakhtiari: 0,
    southKhorasan: 0,
    razaviKhorasan: 0,
    northKhorasan: 0,
    khuzestan: 0,
    zanjan: 0,
    semnan: 0,
    sistanAndBaluchestan: 0,
    fars: 0,
    qazvin: 0,
    qom: 0,
    kurdistan: 0,
    kerman: 0,
    kohgiluyehAndBoyerAhmad: 0,
    kermanshah: 0,
    golestan: 0,
    gilan: 0,
    lorestan: 0,
    mazandaran: 0,
    markazi: 0,
    hormozgan: 0,
    hamadan: 0,
    yazd: 0,
  });

  const [isRunning, setIsRunning] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        if (health != "license-false") {
          getMapData();
        }
      }, 5000);
    } else {
      clearInterval(intervalRef.current);
    }
    // Cleanup on unmount or when isRunning changes
    return () => clearInterval(intervalRef.current);
  }, [isRunning, props.application, props.eventType, health]);

  useEffect(() => {
    if (health != "license-false") {
      getMapData();
    }
  }, [props.daysAgo, props.application, props.eventType, health]);

  useEffect(() => {
    if (props.daysAgo == 0) {
      setIsRunning(true);
    } else {
      setIsRunning(false);
    }
  }, [props.daysAgo]);

  const getMapData = async () => {
    try {
      setIsReady(false);
      const res = await getMapDataService(
        props.daysAgo == 0 ? 1 : props.daysAgo,
        props.application ? props.application?.package_name : "",
        props.eventType
      );

      const tempDeviceCount = { ...deviceCount };
      const tempTotalRisk = { ...totalRisk };

      res.map((item) => {
        switch (item.province) {
          case "Alborz":
            tempDeviceCount.alborz = item.device_count;
            tempTotalRisk.alborz = item.total_risk;
            break;
          case "Ardabil":
            tempDeviceCount.ardabil = item.device_count;
            tempTotalRisk.ardabil = item.total_risk;
            break;
          case "Bushehr":
            tempDeviceCount.bushehr = item.device_count;
            tempTotalRisk.bushehr = item.total_risk;
            break;
          case "Chaharmahal and Bakhtiari":
            tempDeviceCount.chaharmahalandBakhtiari = item.device_count;
            tempTotalRisk.chaharmahalandBakhtiari = item.total_risk;
            break;
          case "East Azerbaijan":
            tempDeviceCount.eastAzerbaijan = item.device_count;
            tempTotalRisk.eastAzerbaijan = item.total_risk;
            break;
          case "Fars":
            tempDeviceCount.fars = item.device_count;
            tempTotalRisk.fars = item.total_risk;
            break;
          case "Gilan":
            tempDeviceCount.gilan = item.device_count;
            tempTotalRisk.gilan = item.total_risk;
            break;
          case "Golestan":
            tempDeviceCount.golestan = item.device_count;
            tempTotalRisk.golestan = item.total_risk;
            break;
          case "Hamadan":
            tempDeviceCount.hamadan = item.device_count;
            tempTotalRisk.hamadan = item.total_risk;
            break;
          case "Hormozgan":
            tempDeviceCount.hormozgan = item.device_count;
            tempTotalRisk.hormozgan = item.total_risk;
            break;
          case "Ilam":
            tempDeviceCount.ilam = item.device_count;
            tempTotalRisk.ilam = item.total_risk;
            break;
          case "Isfahan":
            tempDeviceCount.isfahan = item.device_count;
            tempTotalRisk.isfahan = item.total_risk;
            break;
          case "Kerman":
            tempDeviceCount.kerman = item.device_count;
            tempTotalRisk.kerman = item.total_risk;
            break;
          case "Kermanshah":
            tempDeviceCount.kermanshah = item.device_count;
            tempTotalRisk.kermanshah = item.total_risk;
            break;
          case "Khuzestan":
            tempDeviceCount.khuzestan = item.device_count;
            tempTotalRisk.khuzestan = item.total_risk;
            break;
          case "Kohgiluyeh and Boyer-Ahmad":
            tempDeviceCount.kohgiluyehAndBoyerAhmad = item.device_count;
            tempTotalRisk.kohgiluyehAndBoyerAhmad = item.total_risk;
            break;
          case "Kurdistan":
            tempDeviceCount.kurdistan = item.device_count;
            tempTotalRisk.kurdistan = item.total_risk;
            break;
          case "Lorestan":
            tempDeviceCount.lorestan = item.device_count;
            tempTotalRisk.lorestan = item.total_risk;
            break;
          case "Markazi":
            tempDeviceCount.markazi = item.device_count;
            tempTotalRisk.markazi = item.total_risk;
            break;
          case "Mazandaran":
            tempDeviceCount.mazandaran = item.device_count;
            tempTotalRisk.mazandaran = item.total_risk;
            break;
          case "North Khorasan":
            tempDeviceCount.northKhorasan = item.device_count;
            tempTotalRisk.northKhorasan = item.total_risk;
            break;
          case "Qazvin":
            tempDeviceCount.qazvin = item.device_count;
            tempTotalRisk.qazvin = item.total_risk;
            break;
          case "Qom":
            tempDeviceCount.qom = item.device_count;
            tempTotalRisk.qom = item.total_risk;
            break;
          case "Razavi Khorasan":
            tempDeviceCount.razaviKhorasan = item.device_count;
            tempTotalRisk.razaviKhorasan = item.total_risk;
            break;
          case "Semnan":
            tempDeviceCount.semnan = item.device_count;
            tempTotalRisk.semnan = item.total_risk;
            break;
          case "Sistan and Baluchestan":
            tempDeviceCount.sistanAndBaluchestan = item.device_count;
            tempTotalRisk.sistanAndBaluchestan = item.total_risk;
            break;
          case "South Khorasan":
            tempDeviceCount.southKhorasan = item.device_count;
            tempTotalRisk.southKhorasan = item.total_risk;
            break;
          case "Tehran":
            tempDeviceCount.tehran = item.device_count;
            tempTotalRisk.tehran = item.total_risk;
            break;
          case "West Azerbaijan":
            tempDeviceCount.westAzerbaijan = item.device_count;
            tempTotalRisk.westAzerbaijan = item.total_risk;
            break;
          case "Yazd":
            tempDeviceCount.yazd = item.device_count;
            tempTotalRisk.yazd = item.total_risk;
            break;
          case "Zanjan":
            tempDeviceCount.zanjan = item.device_count;
            tempTotalRisk.zanjan = item.total_risk;
            break;
          default:
            break;
        }
      });

      setTotalRisk(tempTotalRisk);
      setTotalRisk(tempDeviceCount);

      setIsReady(true);
    } catch (error) {
      HandleErrors(error);
      setIsReady(true);
    }
  };

  return (
    <div>
      {isReady && (
        <IranMap
          data={totalRisk}
          colorRange="254, 124, 0"
          width={"100%"}
          textColor="#000"
          defaultSelectedProvince="tehran"
          deactiveProvinceColor="#fff"
          selectedProvinceColor="#fe7c00  "
          tooltipTitle="تعداد:"
          selectProvinceHandler={(e) => {}}
          key={"map"}
        />
      )}
    </div>
  );
};

export default memo(Map);
